import { createSlice } from "@reduxjs/toolkit"

import { mapCustomPackagingList } from "./customPackaging.service"
import {
  getCustomPackagingList,
  uploadNewCustomBoxImage,
} from "./customPackagingThunkApi"

const initialState: any = {
  loading: "idle",
  customListFetching: "idle",
  myCustomPackagingList: [],
  totalCustomPackagingCount: 0,
}

export const customPackagingSlice = createSlice({
  name: "customPackagingService",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomPackagingList.pending, (state) => {
      state.customListFetching = "pending"
    })
    builder.addCase(getCustomPackagingList.fulfilled, (state, action) => {
      const { records, totalCount } = action.payload
      state.customListFetching = "succeeded"
      state.myCustomPackagingList = records || []
      state.totalCustomPackagingCount = totalCount ?? 0
    })
    builder.addCase(getCustomPackagingList.rejected, (state) => {
      state.customListFetching = "failed"
    })
    builder.addCase(uploadNewCustomBoxImage.pending, (state) => {
      state.loading = "pending"
    })
    builder.addCase(uploadNewCustomBoxImage.fulfilled, (state, action) => {
      // POST returns the full list, so replace it instead of re-fetching via GET.
      const { status, result } = action.payload?.data ?? {}
      if (status === "Success" && Array.isArray(result)) {
        const { records, totalCount } = mapCustomPackagingList(result)
        state.myCustomPackagingList = records
        state.totalCustomPackagingCount = totalCount
      }
      state.loading = "succeeded"
    })
    builder.addCase(uploadNewCustomBoxImage.rejected, (state) => {
      state.loading = "failed"
    })
  },
})
